<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" [showDownload]="true" titleDownload="Download Search Invoiced Orders" (downloadEvent)="ExportSearchedOrder()" (closeEvent)="close()"></child-header>
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="row filter-wrapper">
          <ng-container *ngIf="!hasEmptyResult">
            <div class="col-md-12">
              <div class="searchInputGroup" style="margin-left: 15px;">
                <div class="searchIcon">
                  <img src="../images/new_ui/filter.png">
                </div>
                <input class="searchInput" type="text" placeholder="Filter Orders" [(ngModel)]="searchField"
                  (ngModelChange)="onChange()">
              </div>
            </div>
          </ng-container>
        </div>

        <ng-container *ngIf="(hasEmptyResult && completeSearch) || hasEmptyFilterResult">
          <div class="noResult-wrapper">
            <div class="top-divider"></div>
            <div><img src="../images/new_ui/no-found.png"></div>
            <div class="title">No results found</div>
            <div class="description">Sorry, that search or filter combination has no results.<br>Please try different
              criteria.</div>
            <button *ngIf="hasEmptyFilterResult" class="button button-red button-large" (click)="filterReset()">Try
              again</button>
            <button *ngIf="hasEmptyResult" class="button button-red button-large" [routerLink]="['/myOrder']">Try
              again</button>
          </div>
          <div class="top-divider"></div>
        </ng-container>

        <ng-container *ngIf="!hasEmptyResult && !hasEmptyFilterResult">
          <div class="top-divider"></div>
          <div class="shared-outer-wrapper" style="margin-left: 0px;margin-right: 0px;">
            <!--  -->
            <table matSort (matSortChange)="sortData($event)" class="white">
              <thead>
                <tr class="row">
                  <th style="width: 50%; padding-left: 15px;" mat-sort-header="invoiveNo">INVOICE NO</th>
                  <th style="width: 15%" mat-sort-header="invoiceDate">INVOICE DATE</th>
                  <th style="width: 15%" mat-sort-header="resellerPO">RESELLER PO</th>
                  <th style="width: 10%" mat-sort-header="totalEx">SHIPPED EX</th>
                  <th style="width: 10%"></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let order of sortedData | orderFilterPipe: filterInput">
                  <tr class="row inforow">
                    <td style="width: 50%;padding-left: 15px;">{{order?.orderNo}}{{order?.orderSuffix}}</td>
                    <td style="width: 15%">{{order?.dateInvoiced.split("-").join("/")}}</td>
                    <td style="width: 15%">{{order?.resellerPO}}</td>
                    <!-- <td class="align-right" style="width: 10%; padding-right: 38px;">
                    {{order?.totalEx | currency:'AUD':'symbol-narrow':'.2-2'}}</td> -->
                    <td class="align-right" style="width: 10%; padding-right: 38px;">
                      {{convertTotal(order?.shippedEx)}}</td>
                    <td class="button-wrapper" style="width:10%;">
                      <a [routerLink]="['orderitemdetail/'+ order.orderNo + order?.orderSuffix]" class="red-link"
                        style="margin-left: 7px;">View order</a>
                    </td>
                    <div class="row middlerow">
                      <span class="font-col-secondary" *ngIf="order?.courier">COURIER:&nbsp;</span>
                      <span class="font-col-primary">{{order?.courier}}</span>
                      <span class="divider-wrapper" *ngIf="order?.connote">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                      <span class="font-col-secondary" *ngIf="order?.connote">CONNOTE:&nbsp;</span>
                      <div class="font-col-primary" [innerHTML]="order?.connote"></div>
                    </div>
                    <div class="row downloadrow">
                      <td class="downloadtextcol">Download Documents:</td>
                      <td class="shippeddownloadiconcol">
                        <a [href]="order?.orderConfirmationUrl" target="_blank" *ngIf="order?.orderConfirmationUrl"
                          style="display: inline-block;">
                          <!-- <img src="../images/new_ui/open-orders/order-confirmation-grey.png" placement="bottom"
                          ngbTooltip="Order Confirmation"> -->
                          <span class="basic-icon orderConfirm-icon" placement="bottom"
                            ngbTooltip="Order Confirmation"></span>
                        </a>
                        <a [href]="order?.creditNoteUrl" target="_blank" *ngIf="order?.creditNoteUrl">
                          <!-- <img src="../images/new_ui/open-orders/credit-note-grey.png" placement="bottom"
                          ngbTooltip="Credit Note"> -->
                          <span class="basic-icon creditNote-icon" placement="bottom" ngbTooltip="Credit Note"></span>
                        </a>

                        <a [href]="order?.deliveryDocketUrl" target="_blank" *ngIf="order?.deliveryDocketUrl">
                          <!-- <img src="../images/new_ui/open-orders/delivery-docket-grey.png" placement="bottom"
                          ngbTooltip="Delivery Docket"> -->
                          <span class="basic-icon deliveryDocket-icon" placement="bottom"
                            ngbTooltip="Delivery Docket"></span>
                        </a>

                        <a [href]="order?.invoiceUrl" target="_blank" *ngIf="order?.invoiceUrl">
                          <!-- <img src="../images/new_ui/open-orders/tax-invoice-grey.png" placement="bottom"
                          ngbTooltip="Tax Invoice"> -->
                          <span class="basic-icon taxInvoice-icon" placement="bottom" ngbTooltip="Tax Invoice"></span>
                        </a>
                        <a [href]="order?.licenceAgreeUrl" target="_blank" *ngIf="order?.licenceAgreeUrl">
                          <!-- <img src="../images/new_ui/open-orders/license-agreement-grey.png" placement="bottom"
                          ngbTooltip="License Agreement"> -->
                          <span class="basic-icon licenseAgreement-icon" placement="bottom"
                            ngbTooltip="License Agreement"></span>
                        </a>
                        <a [href]="order?.orderAmendUrl" target="_blank" *ngIf="order?.orderAmendUrl">
                          <!-- <img src="../images/new_ui/open-orders/amendment-grey.png" placement="bottom"
                          ngbTooltip="Amendment"> -->
                          <span class="basic-icon amendment-icon" placement="bottom" ngbTooltip="Amendment"></span>
                        </a>
                        <a [href]="order?.podUrl" target="_blank" *ngIf="order?.podUrl">
                          <!-- <img src="../images/new_ui/open-orders/proof-delivery-grey.png" placement="bottom"
                          ngbTooltip="Proof of Delivery"> -->
                          <span class="basic-icon proofOfDelivery-icon" placement="bottom"
                            ngbTooltip="Proof of Delivery"></span>
                        </a>
                        <a [href]="order?.rmaUrl" target="_blank" *ngIf="order?.rmaUrl">
                          <!-- <img src="../images/new_ui/open-orders/return-authority-grey.png" placement="bottom"
                          ngbTooltip="Return Authority"> -->
                          <span class="basic-icon returnAuthority-icon" placement="bottom"
                            ngbTooltip="Return Authority"></span>
                        </a>
                        <a [href]="order?.resellerPOUrl" target="_blank" *ngIf="order?.resellerPOUrl">
                          <!-- <img src="../images/new_ui/open-orders/purchase-order-grey.png" placement="bottom"
                          ngbTooltip="Purchase Order"> -->
                          <span class="basic-icon purchaseOrder-icon" placement="bottom"
                            ngbTooltip="Purchase Order"></span>
                        </a>
                        <a [href]="order?.supportConUrl" target="_blank" *ngIf="order?.supportConUrl">
                          <!-- <img src="../images/new_ui/open-orders/support-agreement-grey.png" placement="bottom"
                          ngbTooltip="Support Agreement"> -->
                          <span class="basic-icon supportAgreement-icon" placement="bottom"
                            ngbTooltip="Support Agreement"></span>
                        </a>
                        <a *ngIf="order?.hasSerials ==='1'" target="_blank"
                          (click)="exportOrderSerials(order?.orderNo, order?.orderSuffix)">
                          <!-- <img src="../images/new_ui/open-orders/support-agreement-grey.png" placement="bottom"
                            ngbTooltip="Support Agreement"> -->
                          <span class="basic-icon orderSerials-icon" placement="bottom"
                            ngbTooltip="Export Serials"></span>
                        </a>
                        <a [href]="order?.autopilotUrl" target="_blank" *ngIf="order?.autopilotUrl">
                          <!-- <img src="../images/new_ui/open-orders/credit-note-grey.png" placement="bottom"
                ngbTooltip="Credit Note"> -->
                          <span class="basic-icon autopilot-icon" placement="bottom" ngbTooltip="Autopilot"></span>
                        </a>
                      </td>
                    </div>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
      <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
    </div>
  </div>

  <router-outlet></router-outlet>